import { SyntheticEvent } from 'react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { Card } from '@chakra-ui/react';
import classNames from 'classnames';
import { GuideOption } from 'types';
import { CbButton } from 'ui/components/Buttons/CbButton';
import styles from './Option.module.css';
interface OptionProps {
  answered?: boolean;
  isCorrect?: boolean;
  isDisabled: boolean;
  option: GuideOption;
  userSelected?: boolean;
  onSelect: (event: SyntheticEvent) => void;
}

// This function has been revised for clarity and functionality
export const OptionControl = ({
  isCorrect,
  answered = false
}) => {
  if (!answered) {
    // Return the default control before the question is answered
    return <span className={`${styles.optionControl} ${styles.default}`} />;
  }
  return isCorrect ? <CheckIcon className={styles.optionControl} data-sentry-element="CheckIcon" data-sentry-component="OptionControl" data-sentry-source-file="Option.tsx" /> : <CloseIcon className={styles.optionControl} data-sentry-element="CloseIcon" data-sentry-component="OptionControl" data-sentry-source-file="Option.tsx" />;
};
export const Option = ({
  answered,
  isCorrect,
  isDisabled,
  option,
  userSelected,
  onSelect
}: OptionProps) => {
  // Determine background color based on the option's state
  let bgColor: string;
  if (answered && userSelected) {
    bgColor = isCorrect ? 'venasaur.500' : 'kirby.500';
  } else {
    bgColor = 'none'; // No background color if not selected or before answered
  }
  const optionCardClasses = classNames(styles.optionCard, {
    [styles.userSelected]: userSelected,
    [styles.answered]: answered
  });
  const handleSelect = event => {
    // Only allow selection if the option is not disabled (eg. answered)
    if (!isDisabled) {
      onSelect(event);
    }
  };
  return <Card width="100%" height="auto" marginY={2} border="4px solid white" borderRadius="10px" className={optionCardClasses} data-sentry-element="Card" data-sentry-component="Option" data-sentry-source-file="Option.tsx">
      <CbButton variant="unstyled" height="100%" width="100%" padding={2} onClick={handleSelect} justifyContent="flex-start" gap={2} backgroundColor={bgColor} borderRadius="10px" cursor={isDisabled ? 'not-allowed' : 'pointer'} whiteSpace={'normal'} textAlign={'left'} data-sentry-element="CbButton" data-sentry-source-file="Option.tsx">
        <OptionControl isCorrect={isCorrect} answered={answered} data-sentry-element="OptionControl" data-sentry-source-file="Option.tsx" />
        <span className={styles.optionText}>{option.content}</span>
      </CbButton>
    </Card>;
};